<div class="minWrapLate">
    <div class="lateMinutesStyle" [ngClass]="getStatusColor(task.taskGroupStatus)" *ngIf="timeMathResult">
        {{ timeMathResult[0] === 'LATE' ? '-' : '' }}{{ timeMathResult[1] }}<br>
        <span class="minutesTxt">{{ timeMathResult[2] }}</span>
    </div>
</div>

<div class="header">
    <ng-container [ngSwitch]="task.taskType">
        <ng-container *ngSwitchCase="TaskType.Other">
            <div>{{ task.displayName || '--' }}</div>
            <div>
                <div>{{ task.pickupLocation || '--' }}</div>
                <div>{{ task.dropoffLocation || '--' }}</div>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="TaskType.RemoteParking">
            <div class="remote-parking-summary-section">
                <div>{{ task.displayName || '--' }}</div>
                <div>{{ task.plannedStartDateTimeLocal | momentFormat : 'HH:mm'}} - {{
                    task.plannedTaskCompletionDateTime | momentFormat : 'HH:mm' }}</div>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="TaskType.Terminal">
            <div>
                <div>{{ task.displayName || '--' }}</div>
                <div>{{ task.pickupTotal || 0 }} Pick</div>
            </div>
            <div>
                <div>{{ task.plannedTaskCompletionDateTime | momentFormat : 'HH:mm' }}</div>
                <div>{{ task.dropoffTotal || 0 }} Drop</div>
            </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <div>
                <div>{{task.displayName || '--'}}</div>
                <div>{{task.tailNumber || '--' }}</div>
            </div>

            <div>
                <div>
                    {{task.parkingPosition || '--' }}
                </div>

                <div class="flight-status">
                    <span>{{ task.taskType === TaskType.OutboundFlight ? task.destination : task.origin }}</span>
                    <mat-icon
                        [ngClass]="{'downwards':task.taskType==TaskType.InboundFlight, 'upwards': task.taskType=='OutboundFlight'}">
                        flight</mat-icon>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <div>
        <div class="assigned-names" *ngFor="let name of task?.assignedToNames">{{ name }}</div>
    </div>
    <div class="custom-display-show">
        {{ hasCustoms(task.origin) ? 'C' : '' }}
    </div>
</div>

<div class="dispatchDivCircleWrap">
    <ng-container [ngSwitch]="task.taskType">
        <div *ngSwitchCase="TaskType.RemoteParking" class="dispatchDivCircle icon-parking-large"></div>
        <div *ngSwitchCase="TaskType.Terminal" class="dispatchDivIconCircle">
            <mat-icon class="material-icons-outlined" svgIcon="terminal-run"></mat-icon>
        </div>
        <div *ngSwitchDefault class="dispatchDivCircle" [ngClass]="getStatusColor(task.taskGroupStatus)">
            {{task.nonCompletedPassengerCount}}
        </div>
    </ng-container>
</div>

<div class="drag-handle-container">
    <div *ngIf="task.unAssignedTaskIds && task.unAssignedTaskIds.length > 0" class="draggable-summary-elem">
    <!-- <div *ngIf="!(task.assignedToNames || []).length && task.taskGroupStatus !== 'Cancelled'" class="draggable-summary-elem"> -->
        <ng-content></ng-content>
        <mat-icon>open_with</mat-icon>
        <mat-icon class="vanIcon">time_to_leave</mat-icon>
    </div>
</div>